<div class="container">
  <div class="add-mobile-row">
    <div class="card-cate" (click)="openShopPopup('shop', 0, openAddProduct())">
      <div>
        <!-- <i class="icon fa-solid fa-calendar-check"></i> -->
        <i class="icon fa-solid fa-plus"></i>
        <div class="card-cate__title sm">
          Provide Service
        </div>
      </div>
    </div>
    <div class="card-cate"  (click)="openShopPopup('shop', 1, openAddProduct())">
      <div>
        <i class="icon fa-solid fa-handshake"></i>
        <div class="card-cate__title sm">
          Rental
        </div>
      </div>
    </div>
    <div class="card-cate" (click)="openShopPopup('shop', 2, openAddProduct())">
      <div>
        <i class="icon fa-solid fa-gift"></i>
        <div class="card-cate__title sm">
          Donate
        </div>
      </div>
    </div>
    <div class="card-cate" (click)="openShopPopup('loudspeaker', 0)">
      <div>
        <i class="icon fa-solid fa-circle-question"></i>
        <div class="card-cate__title sm">
          Ask
        </div>
      </div>
    </div>
  </div>
  <div class="add">
    <div class="add__card">
      <div class="add__card--body">
        <img loading="lazy" class="main" src="../../../../../../assets/images/community-me/sell.jpeg" alt="" />
        <div class="add__card--body__title">Home Biz</div>
        <div class="add__card--body__desc" [ngClass]="{ open: tab == 'shop' }">
          Services you can provide include:
          <ul>
            <li>Tuition</li>
            <li>Cooked Food</li>
            <li>Changing the lights</li>
            <li>Setting up TaoBao furniture</li>
            <li>Handyman Services</li>
            <li>Delivery Services</li>
            <li>Dog walking services</li>
            <li>Technical help for elderly</li>
          </ul>
        </div>
        <i class="fa-solid fa-angle-down" [ngClass]="{ active: tab == 'shop' }" (click)="tab == 'shop' ? (tab = '') : (tab = 'shop')"></i>
      </div>
      <div class="add__card--footer">
        <div class="images">
          <img loading="lazy" *ngFor="let i of productAllProductList | filterBy : 'type' : null | slice : 0 : 3" src="{{ imgUrl }}{{ i?.primaryImage }}" />
          <div class="text">
            {{ filterByType(null).length ? filterByType(null).length : "" }}
          </div>
        </div>
        <button class="button-2" (click)="openShopPopup('shop', 0, openAddProduct())">Start Selling</button>
      </div>
    </div>
    <div class="add__card">
      <div class="add__card--body">
        <img loading="lazy" class="main" src="../../../../../../assets/images/community-me/rental.jpeg" alt="" />

        <div class="add__card--body__title">Rental</div>
        <div class="add__card--body__desc" [ngClass]="{ open: tab == 'rental' }">
          Things you can rent out include:
          <ul>
            <li>Power Drill</li>
            <li>Balloon Pump</li>
            <li>Ladder</li>
            <li>Camera</li>
            <li>Printer</li>
            <li>Boardgames</li>
            <li>Chairs and Foldable Table</li>
            <li>Bicycle</li>
          </ul>
        </div>
        <i class="fa-solid fa-angle-down" [ngClass]="{ active: tab == 'rental' }" (click)="tab == 'rental' ? (tab = '') : (tab = 'rental')"></i>
      </div>
      <div class="add__card--footer">
        <div class="images">
          <img loading="lazy" *ngFor="let i of productAllProductList | filterBy : 'type' : 'rental' | slice : 0 : 3" src="{{ imgUrl }}{{ i?.primaryImage }}" />
          <div class="text">
            {{ filterByType("rental").length ? filterByType("rental").length : "" }}
          </div>
        </div>
        <button class="button-2" (click)="openShopPopup('shop', 1, openAddProduct())">RENT OUT</button>
      </div>
    </div>
    <div class="add__card">
      <div class="add__card--body">
        <img loading="lazy" class="main" src="../../../../../../assets/images/community-me/donate.jpeg" alt="" />
        <div class="add__card--body__title">Donate</div>
        <div class="add__card--body__desc" [ngClass]="{ open: tab == 'bless' }">
          Things you can Donate:
          <ul>
            <li>Food</li>
            <li>Clothes</li>
            <li>Tickets</li>
            <li>Furniture</li>
            <li>Electronics</li>
          </ul>
        </div>
        <i class="fa-solid fa-angle-down" [ngClass]="{ active: tab == 'bless' }" (click)="tab == 'bless' ? (tab = '') : (tab = 'bless')"></i>
      </div>
      <div class="add__card--footer">
        <div class="images">
          <img loading="lazy" *ngFor="let i of productAllProductList | filterBy : 'type' : 'bless' | slice : 0 : 3" src="{{ imgUrl }}{{ i?.primaryImage }}" />
          <div class="text">
            {{ filterByType("bless").length ? filterByType("bless").length : "" }}
          </div>
        </div>
        <button class="button-2" (click)="openShopPopup('shop', 2, openAddProduct())">Donations</button>
      </div>
    </div>
    <div class="add__card">
      <div class="add__card--body">
        <img loading="lazy" class="main" src="../../../../../../assets/images/community-me/recommend.jpeg" alt="" />
        <div class="add__card--body__title">Ask</div>
        <div class="add__card--body__desc" [ngClass]="{ open: tab == 'recommendation' }">Support your local businesses by recommending them. Each user can only recommend 3 at the beginning. As their level progresses they get more recommendation tokens.</div>
        <i class="fa-solid fa-angle-down" [ngClass]="{ active: tab == 'recommendation' }" (click)="tab == 'recommendation' ? (tab = '') : (tab = 'recommendation')"></i>
      </div>
      <div class="add__card--footer">
        <div class="images">
          <img loading="lazy" *ngFor="let i of productAllProductList | filterBy : 'type' : 'recommendation' | slice : 0 : 3" src="{{ imgUrl }}{{ i?.primaryImage }}" />
          <div class="text">
            @if(askList?.length) {
            <i class="fa-solid fa-circle-question"></i>
            {{ askList?.length }}
            }
          </div>
        </div>
        <button class="button-2" (click)="openShopPopup('loudspeaker', 0)">ASK A QUESTION</button>
      </div>
    </div>
  </div>
  
  <!-- <div class="add-mobile">
    <div class="add-mobile__card">
      <div class="content">
        <div class="title" (click)="openShopPopup('shop', 0, openAddProduct())">
          <i class="icon fa-house-chimney fa-solid"></i>
          Home Biz
        </div>
        <div class="down" [ngClass]="{ active: tab == 'shop' }" (click)="tab == 'shop' ? (tab = '') : (tab = 'shop')">
          <i class="fa-solid fa-angle-down"></i>
        </div>
        <img loading="lazy" class="main" src="../../../../../../assets/images/community-me/sell.jpeg" alt="" />
      </div>
      <div class="desc" [ngClass]="{ open: tab == 'shop' }">
        <div>
          Services you can provide include:
          <ul>
            <li>Tuition</li>
            <li>Cooked Food</li>
            <li>Changing the lights</li>
            <li>Setting up TaoBao furniture</li>
            <li>Handyman Services</li>
            <li>Delivery Services</li>
            <li>Dog walking services</li>
            <li>Technical help for elderly</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="add-mobile__card">
      <div class="content">
        <div class="title" (click)="openShopPopup('shop', 1, openAddProduct())">
          <i class="icon fa-house-chimney fa-solid"></i>

          Rental
        </div>
        <div class="down" [ngClass]="{ active: tab == 'rental' }" (click)="tab == 'rental' ? (tab = '') : (tab = 'rental')">
          <i class="fa-solid fa-angle-down"></i>
        </div>
        <img loading="lazy" class="main" src="../../../../../../assets/images/community-me/rental.jpeg" alt="" />
      </div>
      <div class="desc" [ngClass]="{ open: tab == 'rental' }">
        <div>
          Things you can rent out include:
          <ul>
            <li>Power Drill</li>
            <li>Balloon Pump</li>
            <li>Ladder</li>
            <li>Camera</li>
            <li>Printer</li>
            <li>Boardgames</li>
            <li>Chairs and Foldable Table</li>
            <li>Bicycle</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="add-mobile__card">
      <div class="content">
        <div class="title" (click)="openShopPopup('shop', 2, openAddProduct())">
          <i class="icon fa-house-chimney fa-solid"></i>

          Donate
        </div>
        <div class="down" [ngClass]="{ active: tab == 'bless' }" (click)="tab == 'bless' ? (tab = '') : (tab = 'bless')">
          <i class="fa-solid fa-angle-down"></i>
        </div>
        <img loading="lazy" class="main" src="../../../../../../assets/images/community-me/donate.jpeg" alt="" />
      </div>
      <div class="desc" [ngClass]="{ open: tab == 'bless' }">
        <div>
          Things you can Donate:
          <ul>
            <li>Food</li>
            <li>Clothes</li>
            <li>Tickets</li>
            <li>Furniture</li>
            <li>Electronics</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="add-mobile__card">
      <div class="content">
        <div class="title" (click)="openShopPopup('loudspeaker', 0)">
          <i class="icon fa-house-chimney fa-solid"></i>
          Ask
        </div>
        <div class="down" [ngClass]="{ active: tab == 'recommendation' }" (click)="tab == 'recommendation' ? (tab = '') : (tab = 'recommendation')">
          <i class="fa-solid fa-angle-down"></i>
        </div>
        <img (click)="openShopPopup('loudspeaker', 0)" loading="lazy" class="main" src="../../../../../../assets/images/community-me/recommend.jpeg" alt="" />
      </div>
      <div class="desc" [ngClass]="{ open: tab == 'recommendation' }">
        <div>Support your local businesses by recommending them. Each user can only recommend 3 at the beginning. As their level progresses they get more recommendation tokens.</div>
      </div>
    </div>
  </div> -->
</div>
